export default Object.freeze({
  no_state:
    "https://assets.fyers.in/verified-pnl/images/illustration-no-state.svg",
  external_link: "https://assets.fyers.in/images/website/icon-open-blank.svg",
  logout_icon: "https://assets.fyers.in/images/global-header/icon-logout.svg",
  fyers_logo: "https://assets.fyers.in/images/logo.svg",
  hamburger_menu:
    "https://assets.fyers.in/verified-pnl/images/hamburger-menu.svg",
  down_arrow_icon: "https://assets.fyers.in/images/website/icon-down-arrow.svg",
  pagination_down_arrow_icon:
    "https://assets.fyers.in/verified-pnl/images/down-arrow.svg",
  user_icon: "https://assets.fyers.in/verified-pnl/images/user.svg",
  document_icon:
    "https://assets.fyers.in/verified-pnl/images/icon-table-list.svg",
  grid_menu_icon:
    "https://assets.fyers.in/verified-pnl/images/icon-grid-menu.svg",
  close_menu_icon: "https://assets.fyers.in/verified-pnl/images/close-menu.svg",
  right_arrow_icon:
    "https://assets.fyers.in/images/website/icon-arrow-right-header.svg",
  fyers_loader_gif:
    "https://assets.fyers.in/verified-pnl/images/fyers-loader-white.gif",
});
